import { PureComponent } from 'react';

export class MappedSquareIcon extends PureComponent {
  render() {
    return (
      <svg viewBox="0 0 60 60" {...this.props}>
        <g fillRule="evenodd" fill="none" strokeWidth="1" stroke="none">
          <g fillRule="nonzero" transform="translate(-766,-274)">
            <g transform="translate(736,250)">
              <g fillOpacity="0.25" fill="#929db3">
                <g />
              </g>
              <g transform="translate(30,24)" id="002-cube">
                <path
                  fill="#b0b4b9"
                  id="Path-3"
                  d="M 5.6577414,9.3954763 C 5.6581114,8.0573816 8.0684822,5.6324477 9.4065767,5.631525 L 50.567293,5.6031413 c 1.064511,0.177419 3.848936,2.7280178 3.84795,3.8072111 l -0.03765,41.2195126 c -7.4e-4,0.810981 -2.911084,3.73915 -3.722063,3.739222 l -41.2685178,0.0036 c -1.2099138,1.07e-4 -3.59061,-2.528945 -3.740682,-3.729516 z M 9.375,9.375 9.3963342,50.643213 50.588627,50.621354 50.625,9.375 Z"
                />
                <path
                  style={{ mixBlendMode: 'multiply' }}
                  fill="currentColor"
                  id="Path"
                  d="M 60,7.5 C 60,11.642303 56.642303,15 52.5,15 48.357697,15 45,11.642303 45,7.5 45,3.357697 48.357697,0 52.5,0 56.642303,0 60,3.357697 60,7.5 Z"
                />
                <path
                  style={{ mixBlendMode: 'multiply' }}
                  fill="currentColor"
                  id="path11"
                  d="M 15,7.5 C 15,11.642303 11.642303,15 7.5,15 3.3576966,15 0,11.642303 0,7.5 0,3.3576966 3.3576966,0 7.5,0 11.642303,0 15,3.3576966 15,7.5 Z"
                />
                <path
                  style={{ mixBlendMode: 'multiply' }}
                  fill="currentColor"
                  id="path13"
                  d="M 15,52.5 C 15,56.642303 11.642303,60 7.5,60 3.3576966,60 0,56.642303 0,52.5 0,48.357697 3.3576966,45 7.5,45 c 4.142303,0 7.5,3.357697 7.5,7.5 z"
                />
                <path
                  style={{ mixBlendMode: 'multiply' }}
                  fill="currentColor"
                  id="path15"
                  d="M 60,52.5 C 60,56.642303 56.642303,60 52.5,60 48.357697,60 45,56.642303 45,52.5 45,48.357697 48.357697,45 52.5,45 c 4.142303,0 7.5,3.357697 7.5,7.5 z"
                />
                <polygon
                  points="5.625,5.625 9.375,5.625 9.375,9.375 5.625,9.375 "
                  fill="#ffffff"
                  id="polygon17"
                />
                <polygon
                  points="54.375,13.125 54.375,16.875 50.625,16.875 50.625,13.125 "
                  fill="#ffffff"
                  id="polygon19"
                  transform="translate(0,-7.5)"
                />
                <polygon
                  points="50.625,45 46.875,45 46.875,41.25 50.625,41.25 "
                  fill="#ffffff"
                  id="polygon21"
                  transform="translate(3.75,9.375)"
                />
                <polygon
                  points="15,50.625 15,54.375 11.25,54.375 11.25,50.625 "
                  fill="#ffffff"
                  id="polygon23"
                  transform="translate(-5.625)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
